import classNames from 'classnames'
import { Phone as PhoneIcon } from 'iconoir-react'
import { startCase } from 'lodash'
import { ReactElement } from 'react'
import type { PersonSummary } from 'app/types/entities'
/**
 * It renders the name of a person in the AI people block section for CallCard component
 * with data about patient type and if it is the caller
 *
 * @param person PersonSummary object
 * @param isCaller boolean to check if the person is the caller
 * @returns
 */
export function PersonName({ person, isCaller }: { person: PersonSummary; isCaller: boolean }): ReactElement {
  return (
    <>
      <span className="text-trn-black shrink-0 text-left text-ui-xs">{startCase(person.name || `Unknown`)}</span>
      <div
        className={classNames(`flex shrink-0 items-center gap-x-1 text-body-xs leading-none`, {
          'text-green-600': person.patientType === `New Patient`,
          'text-red-600': person.patientType === `Non-Patient`,
          'text-subtle': [`Current Patient`, `Other`, undefined].includes(person.patientType),
        })}
      >
        {person.patientType && (
          <>
            <span>·</span>
            <span>{person.patientType}</span>
          </>
        )}
        {isCaller && (
          <>
            <span>·</span>
            <PhoneIcon height={13} width={13} className="text-blue-600" aria-hidden="true" />
          </>
        )}
      </div>
    </>
  )
}
